export default "__VITE_ASSET__8390bdd2__"